export default "__VITE_ASSET__BcksjsJK__"